import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { useFormData } from "./useFormData";
import { useAppDispatch } from "../../../store";
import { useDownloadReport } from "../../../lib/hooks/useDownloadReport";
import { updateMailingKey } from "../../../acions/actionsCreators/mailingKeyActions";
import MailingsService from "../../../services/mailings";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../../acions/actionsCreators/messageActions";
import { SUCCESS_PDF_DOWNLOAD } from "../../../lib/constants";

export const useSave = (
  contractId: string,
  form: FormInstance,
  sendToData: any[],
  close: () => void,
  subject?: string,
) => {
  const dispatch = useAppDispatch();

  const [isSaving, setIsSaving] = useState<boolean>(false);

  const { download } = useDownloadReport(setIsSaving);

  const { getFormData } = useFormData(sendToData, contractId, subject);

  const onSave = useCallback(async () => {
    try {
      const req = await form.validateFields();

      setIsSaving(true);

      const formData = getFormData(req);

      const res: any = await MailingsService.createLetter(formData);

      download(MailingsService, res.attachmentIds[0]);

      dispatch(updateMailingKey());

      dispatch(setSuccessMessage(SUCCESS_PDF_DOWNLOAD));

      setIsSaving(false);
      close();
    } catch (e: any) {
      dispatch(setErrorMessage(e.response.data.title, true));
      setIsSaving(false);
    }
  }, [dispatch, form, getFormData, close, download]);

  return { isSaving, onSave, setIsSaving };
};
